import React from 'react';
import { Section } from '../Section';
import { RouteFlow } from '../RouteFlow';
import { TransformCTA } from '../TransformCTA';
const steps = [{
  number: '01',
  title: 'What is the situation?',
  body: 'What clinical scenario are you dealing with?'
}, {
  number: '02',
  title: 'What information matters?',
  body: 'What should be reviewed before moving forward?'
}, {
  number: '03',
  title: 'What decision am I facing?',
  body: 'What is the actual question that needs to be answered?'
}, {
  number: '04',
  title: 'What needs to happen next?',
  body: 'What actions, reassessment, monitoring or follow-up should be considered?'
}, {
  number: '05',
  title: 'Does this require escalation or referral?',
  body: 'What factors should trigger additional evaluation or specialist involvement?'
}];
export function FiveMinuteRoute() {
  return <Section tone="ink" eyebrow="You don’t need another textbook. You need a route." title={<>The 5-Minute Renal Decision Route™</>} subtitle="A structured framework designed to help you navigate common renal scenarios in 5 minutes or less. The objective isn’t to memorize hundreds of pages — it’s to quickly identify what matters." data-id="element-151" data-mp="318g4qunj7v8w">
      <div className="mx-auto mb-10 max-w-3xl space-y-3 text-center" data-id="element-152" data-mp="189zl6t6oehx">
        <p className="text-[13px] font-bold uppercase tracking-wider text-white/50 line-through decoration-[#e0761f] decoration-2" data-id="element-153" data-mp="17ieipx7pz5w">
          Search → Search → Cross-reference → Second-guess
        </p>
        <RouteFlow tone="dark" steps={['Finding', 'Assess', 'Decide', 'Act', 'Monitor', 'Follow up']} data-id="element-154" data-mp="34pa0nnoo3ow6" />
      </div>

      <ol className="space-y-3 sm:grid sm:grid-cols-2 sm:gap-4 sm:space-y-0 lg:grid-cols-3" data-id="element-155" data-mp="3efbpwisrbdco">
        {steps.map(step => <li key={step.number} className="flex h-full flex-col rounded-2xl border border-white/12 bg-white/[0.06] p-5" data-id="element-156" data-mp="2gyeb6x7op5s3">
            <span className="font-display text-3xl font-bold text-cyan-brand" data-id="element-157" data-mp="2dxtcks34ryta">
              {step.number}
            </span>
            <h3 className="mt-2 text-[15.5px] font-extrabold uppercase leading-snug tracking-tight text-white" data-id="element-158" data-mp="29x125viivnvf">
              {step.title}
            </h3>
            <p className="mt-2 text-[14px] leading-relaxed text-white/70" data-id="element-159" data-mp="2npgzcfoqsrof">
              {step.body}
            </p>
          </li>)}
        <li className="flex h-full flex-col justify-center rounded-2xl border border-cyan-brand/40 bg-cyan-brand/10 p-5 text-center" data-id="element-160" data-mp="1uy72m9dzf2nd">
          <p className="font-display text-xl font-bold leading-snug text-white" data-id="element-161" data-mp="1qyybzde8nkw1">
            One scenario. One route. One structured decision process.
          </p>
        </li>
      </ol>

      <TransformCTA tone="dark" label="Give me the 5-minute decision route" sub="Structured pathways for the scenarios you actually see" data-id="element-162" data-mp="1zxa4xm2kuurn" />
    </Section>;
}